import { render, staticRenderFns } from "./PostOperationNotes.vue?vue&type=template&id=20e4c7e2&"
import script from "./PostOperationNotes.vue?vue&type=script&lang=js&"
export * from "./PostOperationNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports